import { render, staticRenderFns } from "./ClassifyItem.vue?vue&type=template&id=47b91a2e&scoped=true"
import script from "./ClassifyItem.vue?vue&type=script&lang=js"
export * from "./ClassifyItem.vue?vue&type=script&lang=js"
import style0 from "./ClassifyItem.vue?vue&type=style&index=0&id=47b91a2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b91a2e",
  null
  
)

export default component.exports